import React from "react";

const StepOne = () => {
  return (
    <div>
      <h1>Step 1</h1>
    </div>
  );
};

export default StepOne;
